import { gql } from "@apollo/client";

export const GET_INLINE_PAST_PERFORMANCE = gql`
  query getRacesList(
    $wagerProfile: String!
    $sortBy: PastRaceListSort
    $entityRunnerId: String
    $limit: Int
  ) {
    pastRaces(
      entityRunnerId: $entityRunnerId
      profile: $wagerProfile
      sort: $sortBy
      page: { results: $limit, current: 0 }
    ) {
      id
      date
      purse
      numRunners
      number
      track {
        id
        code
        name
      }
      surface {
        shortName
        defaultCondition
      }
      distance {
        code
        value
      }
      raceClass {
        shortName
      }
      video {
        replayFileName
        mobileAvailable
        flashAvailable
      }
      results {
        runners {
          finishPosition
          currentOdds {
            numerator
            denominator
          }
          timeform {
            beatenDistance
            beatenDistanceStatus
            accBeatenDistance
            accBeatenDistanceStatus
          }
          favorite
        }
      }
    }
  }
`;
